import { render, staticRenderFns } from "./loginUp.vue?vue&type=template&id=72d1b702&scoped=true"
import script from "./loginUp.vue?vue&type=script&lang=js"
export * from "./loginUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1b702",
  null
  
)

export default component.exports